import logo1 from "../../assets/img/historicEvents/LogoKOTR/1985-1995.png";
import logo2 from "../../assets/img/historicEvents/LogoKOTR/1996-1997.png";
import logo3 from "../../assets/img/historicEvents/LogoKOTR/1998.png";
import logo4 from "../../assets/img/historicEvents/LogoKOTR/1999-2001.png";
import logo5 from "../../assets/img/historicEvents/LogoKOTR/2002.png";
import logo6 from "../../assets/img/historicEvents/LogoKOTR/2015.png";
import logo7 from "../../assets/img/historicEvents/LogoKOTR/2024.png";

export const kingOfTheRingDetail = {
  "king-of-the-ring": {
    id: "king-of-the-ring",
    title: "King of the Ring",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "king-of-the-ring",
        items: [
          {
            id: "king-of-the-ring-1985",
            title: "King Of The Ring",
            description: "1985 - 1991",
            imgUrl: logo1,
          },
          {
            id: "king-of-the-ring-1993",
            title: "King Of The Ring",
            description: "Who Will Be King? Be A Part Of the Coronation! 1993",
            imgUrl: logo1,
          },
          {
            id: "king-of-the-ring-1994",
            title: "King Of The Ring",
            description: "The Perfect Father's Day Card 1994",
            imgUrl: logo1,
          },
          {
            id: "king-of-the-ring-1995",
            title: "King Of The Ring",
            description: "Guts & Glory 1995",
            imgUrl: logo1,
          },
          {
            id: "king-of-the-ring-1996",
            title: "King Of The Ring",
            description: "To Battle Is Honor... To Win Is Hell! 1996",
            imgUrl: logo2,
          },
          {
            id: "king-of-the-ring-1997",
            title: "King Of The Ring",
            description: "It's Bound to Get Medieval. Brace Yourself. 1997",
            imgUrl: logo2,
          },
          {
            id: "king-of-the-ring-1998",
            title: "King Of The Ring",
            description: "Off With Their Heads 1998",
            imgUrl: logo3,
          },
          {
            id: "king-of-the-ring-1999",
            title: "King Of The Ring",
            description: "Reliving the War 1999",
            imgUrl: logo4,
          },
          {
            id: "king-of-the-ring-2000",
            title: "King Of The Ring",
            description: "Coronation of a King 2000",
            imgUrl: logo4,
          },
          {
            id: "king-of-the-ring-2001",
            title: "King Of The Ring",
            description: "My Muscles Ache. My Mind Is Spent. My Body Is Broken. Lead me to my throne. 2001",
            imgUrl: logo4,
          },
          {
            id: "king-of-the-ring-2002",
            title: "King Of The Ring",
            description: "2002",
            imgUrl: logo5,
          },
          {
            id: "king-of-the-ring-2015",
            title: "King Of The Ring",
            description: "2015",
            imgUrl: logo6,
          },
          {
            id: "king-of-the-ring-2024",
            title: "King and Queen Of The Ring",
            description: "2024",
            imgUrl: logo7,
          },
        ],
      },
    ],
  },
};
